import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { vehiclesRoutes } from './routes'
import { vehiclesPath } from './index'
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths'

const wrappedVehiclesRoutes = wrapRoutesWithRouter(vehiclesRoutes)
import { VehiclesLayout } from './VehiclesLayout'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { VehiclesProvider } from '../shared/context/vehicles/VehiclesContext'
import { TaskProvider } from '../shared/context/TaskContext'
import { PermissionGuard } from '../shared/components/NoPermission'
import { moduleAccess } from '../shared/permissions'

const VehiclesModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
        <TaskProvider>
            <AppLayoutDahboardWithNav>
            {/* Guard nad providerem: ten od razu pobiera grupy i listę pojazdów. */}
            <PermissionGuard companyId={companyId} {...moduleAccess.vehicles}>
            <VehiclesProvider>
                  <ErrorBoundary
                    fallback={(e) => (
                      <ErrorFallback error={e.error} onRetry={e.reset} />
                    )}
                  >
                    <Routes>
                      {wrappedVehiclesRoutes.map((route) => (
                        <Route
                            key={route.path}
                            path={`${toRelativeRoute(route.path, vehiclesPath)}/*`}
                            element={
                              <VehiclesLayout
                                companyId={companyId!}
                                viewControlBar={route.viewControlBar}
                                navigation={route.navigation}
                                heightScreen={route.heightScreen}
                              >
                                <route.Component />
                              </VehiclesLayout>
                            }
                          />
                      ))}

                      {/* fallback */}
                      <Route
                        path="*"
                        element={
                          <VehiclesLayout companyId={companyId!}>
                            <div>Select</div>
                          </VehiclesLayout>
                        }
                      />
                    </Routes>
                  </ErrorBoundary>
            </VehiclesProvider>
            </PermissionGuard>
            </AppLayoutDahboardWithNav>
        </TaskProvider>
    </ErrorBoundary>
  )
}

export const VehiclesModule = VehiclesModuleImpl
